import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { Tc, TcPerfilUsuarioEnum } from '../../../core/_infrastructure/types/common';
import { DatePipe, DecimalPipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { SolicitudExService } from '../datosbasicos/datosbasicosEx.service';
import { ProductosExService } from './productosEx.service';
import { TwEmbalajesExViewModel, SolicitudProductosExViewModel } from './productosEx.types';
import { EnumIdsTwTcTipoClonacion, EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { HttpParams } from '@angular/common/http';
import { EnumIdsTwTcSubTipoSolicitudEx, EnumIdsTcEstadoSolicitudEx } from '../types/enum';

@Component({
    selector: 'app-embalajesex-edit',
    templateUrl: './embalajesEx-edit.component.html',
})
export class EmbalajeExEditComponent extends ComponentBase implements OnInit {
    editMode = false;
    editTitle = 'Nuevo';
    codigoSolicitud: string;
    tituloTipoSolicitudEx: string;
    tituloEstadoSolicitudEx: string;
    codigoTipoSolicitud: string;
    IdEstadoSolicitudEx: number;
    IdEstadoCertificadoFitoEx: number;
    tituloEstadoCertificadoFitoEx: string;
    IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    IdSubTipoSolicitudEx: number | null;
    IdSubTipoSolicitudExDescripcion: string;
    campoObligatorio = true;

    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;

    listPais: Tc[];
    listTaric: Tc[];
    listEppo: Tc[];
    listUnidad: Tc[];

    IdPaisOrigen: number;

    IdSolicitudEx: number;
    IdGrabador: number | null = null;

    solicitudProductosEx: SolicitudProductosExViewModel;
    embalajeEx: TwEmbalajesExViewModel;

    habilitarGuardar = true;
    habilitarEdicion = true;
    habilitarBusquedaEppo = false;
    visibilitySpinner = false;
    esClonada = false;
    laHeGrabadoYo = false;

    public isCollapsedDatosBasicos = false;

    constructor(
        public datepipe: DatePipe,
        public decimalPipe: DecimalPipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private navMenuService: NavMenuService,
        private solicitudExService: SolicitudExService,
        private productoExService: ProductosExService,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.solicitudProductosEx = new SolicitudProductosExViewModel();
        //this.producto = new TProductoSolicitudViewModel();
        this.embalajeEx = new TwEmbalajesExViewModel();
    }

    ngOnInit() {
        this.globalService.getAllPaisesExpor().subscribe(res => {
            this.listPais = res;
        });
        this.productoExService.getTaricEmbalaje().subscribe(result => {
            this.listTaric = result;
        });
        this.productoExService.getEppoEmbalaje().subscribe(result => {
            this.listEppo = result;
        });

        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];
        let idemb = +this.activatedRoute.snapshot.params['idemb'];

        this.IdSolicitudEx = id;
        //Para que se abran las pestañas de la solicitud
        this.guardRefreshPage(id);

        //EDIT DE EMBALAJE
        if (idemb) {
            this.editMode = true;
            this.editTitle = 'Editar';

            //Para saber si se actua como Inspector o Grabador
            let params = new HttpParams();
            params = params.append('idSolicitudEx', id.toString());
            params = params.append('idUsuario', this.loggedInUser!.Id.toString());

            this.solicitudExService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {
                this.laHeGrabadoYo = resultIsGrabada;

                this.productoExService.getEmbalajeEx(idemb).subscribe(result => {
                    this.embalajeEx = result;

                    this.productoExService.getUnidadEmbalajeByIdTaric(this.embalajeEx.IdTaric).subscribe(result => {
                        this.listUnidad = result;
                    });

                    this.IdEstadoSolicitudEx = this.embalajeEx.IdEstadoSolicitudEx;
                    this.IdEstadoCertificadoFitoEx = this.embalajeEx.IdEstadoCertificadoFitoEx;
                    this.codigoSolicitud = this.embalajeEx.Codigo;
                    this.tituloTipoSolicitudEx = this.embalajeEx.IdTipoSolicitudExDescripcion;
                    this.tituloEstadoCertificadoFitoEx = this.embalajeEx.IdEstadoCertificadoFitoExDescripcion;

                    this.tituloEstadoSolicitudEx = this.embalajeEx.IdEstadoSolicitudExDescripcion;
                    this.codigoTipoSolicitud = this.embalajeEx.CodigoTipoSolicitud;

                    this.IdResultadoEnvioMuestrasLaboratorioEx = this.embalajeEx.IdResultadoEnvioMuestrasLaboratorioEx;
                    this.DescripcionIdResultadoEnvioMuestrasLaboratorioEx = this.embalajeEx.DescripcionIdResultadoEnvioMuestrasLaboratorioEx;

                    this.IdSubTipoSolicitudEx = this.embalajeEx.IdSubTipoSolicitudEx;
                    this.IdSubTipoSolicitudExDescripcion = this.embalajeEx.IdSubTipoSolicitudExDescripcion;

                    this.esClonada =
                        this.embalajeEx.TwSolicitudJerarquiaEx != null &&
                        this.embalajeEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                            ? true
                            : false;

                    this.updateForm();

                    //Si soy Inspector-Grabador
                    if (this.isGrabador && this.isInspector) {
                        this.habilitarGuardar =
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION, this.embalajeEx.IdEstadoSolicitudEx, undefined)
                                .Visible && this.laHeGrabadoYo;
                        this.habilitarEdicion =
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION, this.embalajeEx.IdEstadoSolicitudEx, undefined)
                                .Visible && this.laHeGrabadoYo;
                    } else {
                        this.habilitarGuardar = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION,
                            this.embalajeEx.IdEstadoSolicitudEx,
                            undefined,
                        ).Visible;
                        this.habilitarEdicion = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION,
                            this.embalajeEx.IdEstadoSolicitudEx,
                            undefined,
                        ).Visible;
                    }

                    //this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION, this.embalajeEx.IdEstadoSolicitudEx, undefined).Visible;
                    //this.habilitarEdicion = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION, this.embalajeEx.IdEstadoSolicitudEx, undefined).Visible;

                    if (!this.habilitarEdicion) {
                        //metodo para deshabilitar los controles
                        this.DisableControlsConsulta();
                    }

                    //SI ES PREVIA
                    if (this.embalajeEx.EsPrevia) {
                        if (
                            this.embalajeEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                            this.embalajeEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                        ) {
                            this.tituloTipoSolicitudEx += '-Previa';
                        }
                        //Si es PREVIA SIN CODIGO se eliminan validaciones
                        if (this.embalajeEx.Codigo == null) {
                            //this.RemoveValidationsPrevia();
                            this.campoObligatorio = false;
                        }
                    }
                });
            });
        } //FIN EDIT EMBALAJE

        //ALTA DE EMBALAJE
        else {
            //SI ES ALTA SOLO CARGO LA INFORMACIÓN PARA LOS ICONOS
            this.productoExService.getSolicitudProductosEx(id).subscribe(result => {
                this.solicitudProductosEx = result;

                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES,
                    this.solicitudProductosEx.IdEstadoSolicitudEx,
                    undefined,
                ).Visible;
                if (!this.habilitarGuardar) {
                    //metodo para deshabilitar los controles
                    this.DisableControlsConsulta();
                }

                this.IdEstadoSolicitudEx = this.solicitudProductosEx.IdEstadoSolicitudEx;
                this.IdEstadoCertificadoFitoEx = this.solicitudProductosEx.IdEstadoCertificadoFitoEx;
                this.codigoSolicitud = this.solicitudProductosEx.CodigoSolicitud;
                this.tituloTipoSolicitudEx = this.solicitudProductosEx.IdTipoSolicitudExDescripcion;
                this.tituloEstadoCertificadoFitoEx = this.solicitudProductosEx.IdEstadoCertificadoFitoExDescripcion;

                this.tituloEstadoSolicitudEx = this.solicitudProductosEx.IdEstadoSolicitudExDescripcion;
                this.codigoTipoSolicitud = this.solicitudProductosEx.CodigoTipoSolicitud;

                this.IdResultadoEnvioMuestrasLaboratorioEx = this.solicitudProductosEx.IdResultadoEnvioMuestrasLaboratorioEx;
                this.DescripcionIdResultadoEnvioMuestrasLaboratorioEx = this.solicitudProductosEx.DescripcionIdResultadoEnvioMuestrasLaboratorioEx;

                this.IdSubTipoSolicitudEx = this.solicitudProductosEx.IdSubTipoSolicitudEx;
                this.IdSubTipoSolicitudExDescripcion = this.solicitudProductosEx.IdSubTipoSolicitudExDescripcion;

                //this.esClonada = this.solicitudProductosEx.TwSolicitudJerarquia != null && this.solicitudProductosEx.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION ? true : false;

                //SI ES PREVIA
                if (this.solicitudProductosEx.EsPrevia) {
                    if (
                        this.solicitudProductosEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                        this.solicitudProductosEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                    ) {
                        this.tituloTipoSolicitudEx += '-Previa';
                    }
                    //Si es PREVIA SIN CODIGO se eliminan validaciones
                    if (this.solicitudProductosEx.CodigoSolicitud == null) {
                        //this.RemoveValidationsPrevia();
                        this.campoObligatorio = false;
                    }
                }
            });
        } //FIN DE ALTA DE EMBALAJE

        //Contenedores, abrimos solo el primero
        this.isCollapsedDatosBasicos = false;
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    //private RemoveValidationsPrevia() {
    //    this.removeValidators("NumeroDeclaracionSumaria");
    //}

    private DisableControlsConsulta() {
        this.form.controls['IdTaric'].disable();
        this.form.controls['IdEppo'].disable();
        this.form.controls['IdUnidad'].disable();
        this.form.controls['IdPais'].disable();
        this.form.controls['Recuento'].disable();
    }

    createForm() {
        this.form = this.fb.group({
            IdTaric: [null, Validators.required],
            IdEppo: [null, Validators.required],
            IdUnidad: [null, Validators.required],
            IdPais: [null, Validators.required],
            Recuento: [null, Validators.required],
        });
    }

    updateForm() {
        this.form.setValue({
            IdTaric: this.embalajeEx.IdTaric,
            IdEppo: this.embalajeEx.IdEppo,
            IdUnidad: this.embalajeEx.IdUnidad,
            IdPais: this.embalajeEx.IdPais,
            Recuento: this.embalajeEx.Recuento,
        });
    }

    saveEmbalaje() {
        this.visibilitySpinner = true;
        this.onSubmit();
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.visibilitySpinner = false;
            this.addErrorMessage('Revise los datos del embalaje');

            this.isCollapsedDatosBasicos = false;

            return;
        }

        let embalajeEx = new TwEmbalajesExViewModel();

        embalajeEx.IdTaric = this.form.value.IdTaric;
        embalajeEx.IdEppo = this.form.value.IdEppo;
        embalajeEx.IdUnidad = this.form.value.IdUnidad;
        embalajeEx.IdPais = this.form.value.IdPais;
        embalajeEx.Recuento = this.form.value.Recuento;

        embalajeEx.IdSolicitudEx = this.IdSolicitudEx;
        embalajeEx.Id = this.embalajeEx.Id;

        if (this.editMode) {
            this.productoExService.editEmbalajeEx(embalajeEx).subscribe({
                next: () => {
                    this.addSuccessMessage('Embalaje modificado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedDatosBasicos = false;
                },
            });
        } else {
            this.productoExService.createEmbalajeEx(embalajeEx).subscribe({
                next: () => {
                    this.addSuccessMessage('Embalaje creado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedDatosBasicos = false;
                },
            });
        }
    }

    onSelectTaric() {
        const idTaric = this.form.value.IdTaric;

        this.productoExService.getUnidadEmbalajeByIdTaric(idTaric).subscribe(result => {
            this.listUnidad = result;
        });

        this.form.patchValue({
            IdUnidad: null,
        });
    }

    onBack() {
        this.router.navigate(['/exportacion/solicitud/productosEx', this.IdSolicitudEx]);
        //Usamos el location ya que hay diferentes formas de llegar aquí­
        //this._location.back();
    }
}
